export default "__VITE_PUBLIC_ASSET__ca4eac64__"